import { Reveal, SectionHeader } from "@/components/Reveal";
import { CHAPTERS } from "@/lib/data";

const Manifesto = () => (
  <section id="apropos" data-testid="manifesto-section" className="relative py-24 lg:py-32 bg-[#EEF3F9]">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <SectionHeader
        caption="Pourquoi Solubail"
        title="Notre manifeste en quatre chapitres"
      />

      <div className="mt-14">
        {CHAPTERS.map((chapter, i) => (
          <Reveal key={chapter.number} delay={0.05}>
            <div
              data-testid={`manifesto-chapter-${i}`}
              className="group grid md:grid-cols-[140px_1.35fr_1.65fr] gap-4 md:gap-8 items-baseline py-10 border-t border-slate-900/10 last:border-b hover:bg-slate-900/[0.03] transition-colors duration-500 px-2 md:px-6 -mx-2 md:-mx-6"
            >
              <span className="font-display text-6xl md:text-7xl font-extrabold text-transparent [-webkit-text-stroke:1.5px_rgba(2,132,199,0.55)] group-hover:[-webkit-text-stroke:1.5px_rgba(2,132,199,1)] transition-all duration-500">
                {chapter.number}
              </span>
              <h3 className="font-display text-xl md:text-2xl font-bold uppercase tracking-tight text-slate-900">
                {chapter.title}
              </h3>
              <p className="text-sm md:text-base text-slate-500 leading-relaxed">
                {chapter.description}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Manifesto;
